import { render, staticRenderFns } from "./CascaderCity.vue?vue&type=template&id=204b923a&scoped=true&"
import script from "./CascaderCity.vue?vue&type=script&lang=js&"
export * from "./CascaderCity.vue?vue&type=script&lang=js&"
import style0 from "./CascaderCity.vue?vue&type=style&index=0&id=204b923a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204b923a",
  null
  
)

export default component.exports